import { render, staticRenderFns } from "./SVTAOverlayContainer.view.vue?vue&type=template&id=0449a163&"
import script from "./SVTAOverlayContainer.view.vue?vue&type=script&lang=js&"
export * from "./SVTAOverlayContainer.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0449a163')) {
      api.createRecord('0449a163', component.options)
    } else {
      api.reload('0449a163', component.options)
    }
    module.hot.accept("./SVTAOverlayContainer.view.vue?vue&type=template&id=0449a163&", function () {
      api.rerender('0449a163', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/SVTAOverlayContainer.view.vue"
export default component.exports